import { useEffect, useRef, type InputHTMLAttributes, type ReactNode } from "react";
import "./checkbox.css";

/** Native checkbox semantics with a full touch target and optional mixed state. */
export function Checkbox({ label, indeterminate = false, className = "", ...props }: Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "children"> & { label?: ReactNode; indeterminate?: boolean }) {
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => { if (input.current) input.current.indeterminate = indeterminate; }, [indeterminate]);
  return <label className={`ui-checkbox ${className}`.trim()}>
    <input {...props} ref={input} type="checkbox" aria-checked={indeterminate ? "mixed" : props["aria-checked"]} />
    {label && <span>{label}</span>}
  </label>;
}
